// 印尼
export default {
  readMore: 'Baca selengkapnya',
  startForFree: 'Coba Gratis Sekarang',
  required: '{name}Tidak bisa kosong',
  tryForFree: 'Uji coba gratis',
  CarouselTitle: 'memberdayakan perusahaan global, membantu bisnis mencapai perkembangan yang stabil.',
  publicConsultation: {
    title1: ' Cloudun ',
    title2: 'AI SaaS',
    title3: 'Konsultasi & Pengalaman',
    item1: 'Iklan AI',
    item2: 'EKYC',
    item3: 'Robot Luna AI',
    item4: 'Layanan Anti-Penipuan',
    item5: 'Layanan Skor Kredit',
    productGroup: 'Produk yang ingin Anda tanyakan adalah',
    submitTip: 'Dengan mengirimkan formulir, Anda setuju bahwa Cloudun dan mitra resminya dapat menghubungi Anda melalui informasi kontak yang Anda berikan, dan data tersebut hanya akan digunakan untuk komunikasi dengan Anda.',
    form: {
      product: 'produk',
      companyName: 'Nama Perusahaan',
      contactPersonName: 'Nama Orang yang Dapat Dihubungi',
      contactPersonPhone: 'Nomor Telepon Orang yang Dapat Dihubungi',
      descriptionOfNeeds: 'Deskripsi Kebutuhan'
    }
  },
  home: {
    title1: 'Artificial Intelligence (AI)',
    title2: 'Memperkuat digital finansial dengan',
    EKYC: {
      title1: 'dengan Kemampuan Anti-Penipuan Visual',
      title2: 'Layanan EKYC ',
      ProductTitle1: 'Pengenalan Dokumen',
      ProductSubTitle1: 'Pengenalan akurat lebih dari seratus jenis dokumen dari lebih dari sepuluh negara utama, pendaftaran dokumen yang cepat, lancar, efisien, dan lengkap.',
      ProductTitle2: 'Deteksi Kehidupan',
      ProductSubTitle2: 'Verifikasi cepat apakah pengguna adalah operasi manusia nyata, pencegahan efektif terhadap berbagai serangan penipuan.',
      ProductTitle3: 'Deteksi Wajah Tingkat Lanjut',
      ProductSubTitle3: 'Kemampuan pencarian dan perbandingan visual wajah tingkat lanjut dalam basis data, eksplorasi informasi tersembunyi pengguna lebih lanjut.',
      ProductTitle4: 'Deteksi Penipuan EKYC',
      ProductSubTitle4: 'Mengidentifikasi secara tepat puluhan jenis penipuan ID dan keaktifan, melindungi bisnis Anda dari risiko penipuan.'
    },
    creditScore: {
      title1: ' Tepat Didukung Oleh Big Data Yang Sangat Besar. ',
      title2: 'MODEL PENILAIAN KREDIT YANG',
      title3: 'Memastikan Pertumbuhan Bisnis Stabil.',
      ProductTitle1: 'Blacklist',
      ProductSubTitle1: 'Berbasis Bigdata yang mencakup lebih dari sepuluh negara global di era digital, secara efektif memblokir pengguna dengan kualitas rendah dan dengan cepat meningkatkan performa bisnis.',
      ProductTitle2: 'Pre-audit',
      ProductSubTitle2: 'Proses penyaringan untu menghindari adanya penilaian ganda terhadap pengguna berdasarkan 3 data indentitas diri.',
      ProductTitle3: 'Audit',
      ProductSubTitle3: 'Dengan mengintegrasikan informasi multidimensi seperti data diri pengguna, perilaku pengguna, dan data pendukung lainnya, menggunakan model manajemen risiko menghasilkan keputusan penilaian pengendalian risiko.',
      ProductTitle4: 'Limit',
      ProductSubTitle4: 'Perhitungan batas kredit efektif pengguna, mengurangi risiko sekaligus dengan cepat meningkatkan keuntungan bisnis per transaksi.'
    },
    antiFraud: {
      title1: 'Iterasi Berkelanjutan untuk Mempertahankan kemampuan ',
      title2: ' ANTI-FRAUD ',
      title3: 'Terdepan, Untuk Selangkah Lebih Maju',
      ProductTitle1: 'Deteksi Penipuan EKYC',
      ProductTitle2: 'Anti-Fraud Perangkat Seluler',
      ProductTitle3: 'Anti-Fraud IP',
      ProductTitle4: 'Anti-Fraud Kartu Bank',
      standardProduct: 'Anti-Fraud Lokasi Geografi'
    },
    lunaAI: {
      title1: 'Luna AI Robot Panggilan Suara ',
      title2: 'Cara Terbaik untuk Menjangkau Pelanggan Secara Efisien di Era Baru',
      repaymentAITitle: 'Robot Panggilan Suara AI Pengingat Pembayaran',
      repaymentAIText: 'Mengandalkan layanan pusat kontak cloud cerdas Cloudun dan robot AI dengan skrip strategi pembayaran berkinerja tinggi pembelajaran mendalam, kami memberi Anda solusi panggilan suara cerdas terpadu untuk meningkatkan tingkat pembayaran.',
      customerServiceAITitle: 'Robot Panggilan Suara AI Layanan Pelanggan',
      customerServiceAIText: 'Mengandalkan basis pengetahuan dan proses bisnis perusahaan Anda, kami menyesuaikan sistem layanan pelanggan AI unik untuk perusahaan Anda, membuka era baru layanan cerdas online 24 jam.',
      marketingAITitle: 'Robot Panggilan Suara AI Pemasaran',
      marketingAIText: 'Tempat panggilan suara pemasaran AI, memberdayakan pelanggan perusahaan untuk mewujudkan mencapai manajemen nilai siklus kehidupan penuh dan pemasaran cerdas di seluruh perjalanan pelanggan.',
      multilingualAITitle: 'Robot Panggilan Suara AI Multibahasa',
      multilingualAIText: 'Dapatkan langsung staf panggilan suara dialog AI yang dilokalkan dan mirip manusia milik Anda sendiri.',
      LLMVoiceTitle: 'Pakar Dialog Suara Model Besar',
      LLMVoiceText: 'Mengandalkan LLM untuk mengenali secara akurat niat pengguna dan menghasilkan suara obrolan nyata  waktu berdasarkan  skrip obrolan berkualitas tinggi, bangun grup tempat komunikasi tingkat lanjut bisnis Anda dan konversi pengguna secara efisien.',
      intelligentContactTitle: 'Platform Komunikasi Pusat Kontak Cerdas',
      intelligentContactText: 'Platform komunikasi kaya sumber daya, membangun saluran yang stabil dan andal bagi Anda untuk menjangkau pengguna.'
    },
    overseasMarket: {
      title1: 'Tim Operasi Penempatan Luar Negeri Profesional, ',
      title2: 'Memberi Anda Percepatan Penempatan 10 Kali Lipat dan Pertumbuhan Lalu Lintas 10 Kali Lipat.',
      applicationMarketTitle: 'Optimisasi Toko Aplikasi Cerdas',
      applicationMarketText: 'Desainer profesional dan tim operasi menyesuaikan desain toko aplikasi untuk aplikasi Anda, mulai dari mengunggah video hingga operasi komentar grafis, mengambil alih lalu lintas dan meningkatkan konversi unduhan.',
      investmentFlowTitle: 'Konten Iklan AIGC untuk Pasar Luar Negeri',
      investmentFlowText: 'Pembuatan konten AIGC yang cepat secara dramatis mengurangi biaya dan meningkatkan lalu lintas luar negeri.',
      majorTitle: 'Layanan Periklanan Luar Negeri Profesional',
      majorText: 'Tim ahli kami memanfaatkan platform global untuk memberikan akuisisi pengguna besar-besaran dan peningkatan ROI.'
    },
    solution: {
      title: 'Bermitra dengan Kami untuk Pertumbuhan yang Menguntungkan',
      item1Title: 'Solusi Pinjaman Online Lengkap dari Awal hingga Akhir.',
      item1Text: 'Mulai dari konsultasi, pembentukan model bisnis, pengembangan dan penerapan yang disesuaikan, hingga panduan operasional dan analisis operasional pada tahap awal bisnis, dan diakhiri  dengan transfer lengkap strategi operasional dan kode, untuk mencapai solusi bisnis yang komprehensif.',
      item2Title: 'Solusi Lengkap Akuisisi Pengguna Pasar internasional',
      item2Text: 'Mulai dari optimis toko aplikasi, hingga produksi materi multimedia iklan, dan layanan tim periklanan profesional untuk akuisisi pengguna besar-besaran.'
    },
    ISOAuthentication: {
      title: 'Sertifikat',
      item1: 'Cloudun AI telah memperoleh sertifikasi otoritatif internasional ISO27001, memiliki sistem manajemen risiko yang mencakup seluruh proses keamanan informasi, menunjukkan kemampuan komprehensif dari perlindungan data hingga operasi yang sesuai. Kami menjamin keamanan privasi dan rahasia dagang Anda dengan standar terkemuka secara global, membantu bisnis Anda dengan mudah mematuhi peraturan internasional yang ketat seperti GDPR.',
      subTitle: 'Terdaftar dan Diawasi',
      item2: 'Cloudun AI telah memperoleh hampir 20 sertifikat pendaftaran hak cipta perangkat lunak komputer, mewujudkan pembangunan dan perlindungan kekayaan intelektual independen yang mencakup area inti seperti algoritma kontrol risiko inti, komputasi data besar, dan pengenalan tampilan CV. Pencapaian teknologi ini memberikan dukungan kuat untuk peningkatan digital pelanggan, memastikan operasi sistem bisnis yang berkelanjutan, aman, dan stabil.',
      certificate2: 'OJK License'
    },
    businessMap: {
      title: 'Negara yang Kami Layani'
    },
    startFor: {
      title: 'Coba Platform SaaS Cloudun',
      subTitle: 'Percepat Bisnis Anda'
    }
  },
  EKYC: {
    slogan1: 'Dengan Kemampuan Anti-penipuan Visual',
    slogan2: 'EKYC',
    subSlogan: 'Memberikan pengalaman autentikasi yang lebih lancar kepada pelanggan dan data autentikasi EKYC yang lebih andal kepada bisnis anda.',
    trialGuidance: 'Rasakan EKYC Lancar dengan Kemampuan Anti-Penipuan',
    IDDetect: {
      title: 'Pengenalan Dokumen',
      introduction: 'Pengenalan akurat lebih dari seratus jenis dokumen dari lebih sepuluh negara utama, pendaftaran dokumen yang cepat, lancar, efisien, dan lengkap.',
      introductionItem1: 'Solusi SDK klien yang matang, integrasi cepat;',
      introductionItem2: 'Pengalaman interaksi terbaik, tingkat konversi pelanggan yang lebih tinggi;',
      introductionItem3: 'Dukungan untuk semua jenis dokumen di semua negara, dengan tingkat pengenalan hingga 99,9%'
    },
    livenessDetect: {
      title: 'Deteksi kehidupan',
      introduction: 'Verifikasi cepat apakah pengguna adalah manusia nyata, pencegahan efektif terhadap berbagai serangan penipuan.',
      introductionItem1Title: 'Keramahan Pengguna',
      introductionItem1Text: 'Penggunaan yang mudah Pengalaman pengguna yang mulus untuk proses autentikasi yang lancar',
      introductionItem2Title: 'Integrasi Cepat',
      introductionItem2Text: 'Antarmuka autentikasi lengkap dan komprehensif, tidak memerlukan pengembangan front-end sama sekali.',
      introductionItem3Title: 'Dukungan Platform yang Luas',
      introductionItem3Text: 'Mendukung iOS, Android, dan web H5, sehingga memudahkan integrasi dengan berbagai produk Anda.'
    },
    faceDetect: {
      title: 'Deteksi wajah tingkat lanjut',
      introduction: 'Kemampuan pencarian dan perbandingan visual wajah tingkat lanjut dalam basis data, eksplorasi informasi tersembunyi pengguna lebih lanjut.',
      introductionItem1Title: 'Kemampuan Perbandingan Wajah',
      introductionItem1Text: 'Menggunakan teknologi pengenalan dan perbandingan wajah untuk mencocokkan foto selfie pengguna dengan foto ID mereka, sehingga mengkonfirmasi identitas pengguna',
      introductionItem2Title: 'Kemampuan Pencarian Wajah',
      introductionItem2Text: ' Mengambil informasi historis pengguna yang tersimpan di database (riwayat ID, aplikasi, status pembayaran).'
    },
    fraudDetect: {
      title: 'Deteksi penipuan EKYC',
      introduction: 'Mengidentifikasi dengan akurat lebih dari sepuluh jenis penipuan dokumen dan lebih dari sepuluh jenis penipuan kehidupan, melindungi bisnis Anda dari risiko penipuan.',
      exampleItem1: 'Deteksi pemutaran ulang wajah layar',
      exampleItem2: 'Deteksi noda wajah',
      exampleItem3: 'Deteksi ekspresi wajah berlebihan',
      exampleItem4: 'Deteksi penggantian latar belakang AI',
      exampleItem5: 'Deteksi wajah AIGC',
      tip: 'Gambar contoh penipuan di atas telah didesensitisasi'
    },
    feature: {
      featureItem1Label: 'Jumlah Panggilan yang Diproses',
      featureItem1Value: '200.000.000+',
      featureItem2Label: 'Jumlah Negara yang Dicakup oleh Layanan',
      featureItem2Value: '8+',
      featureItem3Label: 'Jumlah Jenis Dokumen yang Didukung oleh OCR',
      featureItem3Value: '50+'
    }
  },
  creditScore: {
    slogan1: 'SKOR KREDIT CLOUDUN UNTUK MEMBANTU',
    slogan2: 'Pertumbuhan Bisnis Yang Stabil',
    subSlogan: 'Memanfaatkan dataset besar dan model kontrol risiko multi-dimensi untuk menilai kelayakan kredit secara akurat, membantu bisnis mengurangi risiko sambil meningkatkan nilai transaksi setiap transaksi dan profitabilitas secara keseluruhan.',
    trialGuidance: 'Meningkatkan kinerja dengan menggunakan model kontrol risiko big data bersama dengan banyak perusahaan maju',
    blacklist: {
      title: 'Blacklist',
      introduction: 'Berbasis Bigdata yang mencakup lebih dari sepuluh negara global di era digital, secara efektif memblokir pengguna dengan kualitas rendah dan dengan cepat meningkatkan performa bisnis.'
    },
    preAudit: {
      title: 'Pre-audit',
      introduction: 'Proses penyaringan untu menghindari adanya penilaian ganda terhadap pengguna berdasarkan 3 data indentitas diri.'
    },
    audit: {
      title: 'Audit',
      introduction: 'Dengan mengintegrasikan informasi multidimensi seperti data diri pengguna, perilaku pengguna, dan data pendukung lainnya, menggunakan model manajemen risiko menghasilkan keputusan penilaian pengendalian risiko.'
    },
    amountLimit: {
      title: 'Limit',
      introduction: 'Perhitungan batas kredit efektif pengguna, mengurangi risiko sekaligus dengan cepat meningkatkan keuntungan bisnis per transaksi.'
    },
    feature: {
      featureItem1Label: 'Negara yang Dilayani',
      featureItem1Value: '8+',
      featureItem2Label: 'Proyek yang Dilayani',
      featureItem2Value: '100+',
      featureItem3Label: 'Panggilan API',
      featureItem3Value: '160 Juta+',
      featureItem4Label: 'Jumlah Pinjaman',
      featureItem4Value: '$5 Miliar+',
      featureItem5Label: 'Iterasi Model',
      featureItem5Value: '500+',
      featureItem6Label: 'Jumlah Fitur',
      featureItem6Value: '200.000+'
    }
  },
  antiFraud: {
    slogan1: 'ANTI-PENIPUAN AI',
    slogan2: 'Selangkah Lebih Maju',
    subSlogan: 'Iterasi Berkelanjutan Untuk Mempertahankan Kemampuan Anti-Fraud Terdepan, Untuk Selangkah Lebih Maju.',
    trialGuidance: 'Akses Cloudun anti-penipuan untuk melindungi bisnis Anda',
    functionIntroduction: 'Dengan makin maraknya taktik penipuan yang terus berkembang, kami memanfaatkan teknologi big data untuk mengekstrak fitur dari informasi yang dimasukkan pengguna dan data perangkat. Ini memungkinkan kami untuk secara menyeluruh mengidentifikasi aktivitas penipuan seperti pemalsuan dokumen dan "brushing" terkoordinasi oleh sindikat penipu, sehingga melindungi bisnis Anda.',
    feature: {
      featureItem1Label: 'Volume Panggilan',
      featureItem1Value: '10,000,000+',
      featureItem2Label: 'Tingkat Identifikasi Pengguna Penipuan',
      featureItem2Value: '95+%',
      featureItem3Label: 'Pengguna Penipuan yang Teridentifikasi',
      featureItem3Value: '1,000,000+',
      featureItem4Label: 'Model Anti-Penipuan Buatan Sendiri yang Diterapkan',
      featureItem4Value: '20+'
    }
  },
  lunaAi: {
    slogan1: 'ROBOT SUARA LUNA AI',
    subSlogan: 'Staf panggilan suara AI, cara terbaik untuk menjangkau pelanggan secara efisien di era baru.',
    subTag1: 'Pengingat Pembayaran Otomatis dengan Suara Robot Al ',
    subTag2: 'Layanan Pelanggan Suara Robot Al',
    subTag3: 'Pemasaran Suara Robot Al',
    trialGuidance: 'Rasakan era baru komunikasi pelanggan',
    repaymentReminder: {
      title: 'Panggilan  Suara  Robot AI Pengingat Pembayaran',
      introduction: 'Mengandalkan layanan pusat kontak cloud cerdas Cloud un dan robot AI dengan skrip strategi pembayaran berkinerja tinggi pembelajaran mendalam, kami memberi Anda solusi panggilan suara cerdas terpadu untuk meningkatkan tingkat pembayaran.',
      introductionItem1: 'Sesuaikan staf AI eksklusif: tetapkan secara akurat gaya bahasa, nada suara, dan nada komunikasi.',
      introductionItem2: 'Sesuaikan berbagai strategi pengingat pembayaran agar sangat cocok dengan metode pengingat untuk berbagai tahap pembayaran pelanggan.',
      introductionItem3: 'Kembangkan strategi panggilan komprehensif untuk secara efektif meningkatkan tingkat pembayaran komprehensif bisnis dan memungkinkan manajemen pembayaran yang cerdas.'
    },
    customerService: {
      title: 'Robot Panggilan Suara AI Layanan Pelanggan',
      introduction: 'Mengandalkan basis pengetahuan dan proses bisnis perusahaan Anda, kami menyesuaikan sistem layanan pelanggan AI unik untuk perusahaan Anda, membuka era baru layanan cerdas online 24 jam.',
      introductionItem1Title: 'Layanan Sepanjang Waktu',
      introductionItem1Text: 'layanan berkelanjutan 24 jam.',
      introductionItem2Title: 'Pembelajaran dan Adaptasi Cerdas',
      introductionItem2Text: 'evolusi pembelajaran cerdas.',
      introductionItem3Title: 'Pengalaman Layanan yang Dipersonalisasi',
      introductionItem3Text: 'pengalaman layanan yang penuh perhatian.'
    },
    marketing: {
      title: 'Robot Panggilan Suara AI Pemasaran',
      introduction: 'Dapatkan langsung staf panggilan suara dialog AI yang dilokalkan dan mirip manusia milik Anda sendiri.',
      introductionItem1: 'Interaksi Suara Cerdas 1v1: Memahami niat pelanggan dengan akurat, menangkap kesempatan pemasaran dengan tepat, dan meningkatkan konversi pelanggan.',
      introductionItem2: 'Templat pemasaran siklus hidup penuh: mencakup kecerdasan panggilan otomatis dan perpustakaan skrip dialog untuk seluruh rantai pembuatan prospek, tindak lanjut, konversi, dan pembelian ulang, merekonstruksi model baru untuk pertumbuhan bisnis.',
      introductionItem3: 'Perpustakaan skrip dialog ahli pembelajaran: mendukung pengunggahan basis pengetahuan ahli pemasaran internal perusahaan, dengan cepat menyerap esensi dari skrip dialog teratas.'
    },
    multilingual: {
      title: 'Pakar Suara AI Multibahasa',
      introduction: 'Miliki agen AI konversasional yang dipersonalisasi, sangat mirip manusia, berbicara dalam bahasa ibu Anda, hanya dalam satu menit.',
      introductionItem1Title: 'Dialog yang sangat mirip manusia',
      introductionItem1Text: 'kumpulkan teknologi bahasa yang kaya, gunakan teknologi canggih seperti interupsi cerdas dan kelanjutan nada untuk membuat staf AI berkomunikasi lebih cerdas dan dekat dengan metode komunikasi manusia, mengoptimalkan pengalaman dialog. Nada suara yang kaya lebih realistis, membuat pengguna merasa ramah dan mengurangi panggilan yang terputus.',
      introductionItem2Title: 'Pembuatan cepat',
      introductionItem2Text: 'telah mengumpulkan templat robot suara AI multibahasa, yang dapat segera diaktifkan.'
    },
    largeModel: {
      title: 'Pakar Dialog Suara Model Besar',
      introduction: 'Berdasarkan LLM untuk dengan cepat mempelajari skrip percakapan berkualitas tinggi dan secara akurat mengenali niat pengguna, bangun grup kursi komunikasi tingkat lanjut bisnis Anda, dan konversi pengguna secara efisien.',
      introductionItem1Title: 'Pengenalan Niat Pengguna yang Akurat',
      introductionItem1Text: 'berdasarkan model bahasa besar, mengenali niat pengguna secara akurat, memberikan dukungan kuat untuk konversi perilaku pelanggan dan secara signifikan meningkatkan efektivitas bisnis.',
      introductionItem2Title: 'Pembuatan Skrip Dialog Ahli yang Cerdas',
      introductionItem2Text: 'mengandalkan model bahasa besar tingkat lanjut, mengekstrak esensi dari skrip berkualitas tinggi yang besar, dalam arah seperti "pengingat pembayaran", "layanan pelanggan cerdas", dan "promosi pemasaran", menggabungkan informasi pribadi pengguna dan ekspresi niat, langsung menghasilkan skrip komunikasi yang ditargetkan dan profesional, mengoptimalkan efek komunikasi pelanggan secara komprehensif.'
    },
    contactCenter: {
      title: 'Platform Komunikasi Pusat Kontak Cerdas',
      introduction: 'Platform komunikasi kaya sumber daya, membangun layanan yang stabil dan andal bagi Anda untuk menjangkau pengguna',
      introductionItem1Title: 'Sumber Daya yang Kaya',
      introductionItem1Text: 'Mengumpulkan sumber daya komunikasi luar negeri yang berlimpah dan berkualitas tinggi',
      introductionItem2Title: 'Platform Stabil',
      introductionItem2Text: 'platform akses pertukaran komunikasi, sangat andal dan stabil',
      introductionItem3Title: 'Hemat Waktu dan Upaya',
      introductionItem3Text: ' integrasi sumber daya multi-negara dan multi-jaringan, akses API satu atap'
    },
    feature: {
      featureItem1Title: 'Integrasi Cepat di Hari yang Sama',
      featureItem1: '- Robot Suara Multibahasa Siap Pakai',
      featureItem2: '- Templat Pengenalan Niat dan Dialog Pra-bangun untuk Rencana Pembayaran di Berbagai Negara',
      featureItem3: '- Penyelesaian Cepat Basis Pengetahuan Layanan Pelanggan melalui Pengunggahan Korpus Layanan',
      featureItem2Title: 'Tingkatkan Tingkat Jangkauan Pengguna Lebih dari',
      featureItem3Title: 'Tingkatkan Tingkat Pembayaran Lebih dari'
    }
  },
  aiAds: {
    slogan1: 'LAYANAN IKLAN AI',
    slogan2: 'Akses Ke Jumlah Pengunjung Yang Besar',
    subSlogan: 'Bersama tim iklan Cloudun, percepat akuisisi lalu lintas pasar luar negeri Anda: percepatan penempatan 10 kali lipat, pertumbuhan lalu lintas 10 kali lipat',
    subTag1: 'Penempatan media sosial',
    subTag2: 'Produksi materi iklan',
    subTag3: 'Lalu lintas toko aplikasi',
    subTag4: 'Pasar luar negeri',
    trialGuidance: 'Dapatkan Layanan Lalu Lintas Besar Sekarang',
    furnish: {
      title: 'Dekorasi toko aplikasi',
      introduction: 'Desainer profesional dan tim operasi menyesuaikan desain dekorasi toko aplikasi untuk Aplikasi Anda, dari mengunggah video hingga operasi komentar grafis, menerima lalu lintas untuk meningkatkan konversi unduhan.',
      introductionItem1: 'Logo aplikasi, gambar unggahan App Store, video, dan teks yang disesuaikan (desain UI dan AIGC)',
      introductionItem2: 'Tim profesional 1v1 untuk melayani Anda.'
    },
    material: {
      title: 'Produksi materi penempatan lalu lintas cerdas pasar luar negeri',
      introduction: '"Dengan kemampuan generasi AIGC multimedia yang kuat, Anda dapat dengan cepat memproduksi jumlah besar video iklan dan kreatif gambar/teks berkualitas tinggi. Secara signifikan mengurangi biaya produksi konten iklan dan membuka era baru dalam akuisisi lalu lintas luar negeri berkualitas tinggi dan volume besar.',
      introductionItem1: 'Iklan Video Manusia Digital AIGC Asli',
      introductionItem2: 'Iklan Video Manusia Digital AIGC Menggantikan Video',
      introductionItem3: 'Iklan Gambar dan Teks AIGC Asli',
      introductionItem4: 'Dukungan Multi-Bahasa'
    },
    feature: {
      featureItem1Label: 'Iklan Kreatif yang Didukung',
      featureItem1Value: 'Bahasa  8 Negara',
      featureItem2Label: 'Unduhan Toko Tingkat Konversi Aplikasi',
      featureItem2Value: '+50%',
      featureItem3Label: 'ROI Iklan Meningkat sebesar',
      featureItem3Value: '+30%'
    }
  },
  company: {
    title: 'Cloudun AI Mendukung Perusahaan Keungan Global',
    submitTitle: 'Memanfaatkan teknologi AI yang dikembangkan sendiri dan FinTech, Cloudun memberdayakan perusahaan keuangan global untuk meningkatkan efisiensi layanan keuangan, menghadirkan produk dan layanan keuangan yang lebih baik kepada konsumen.',
    companyHistory: {
      title: 'Solusi AI Keuangan Digital Cloudun',
      item2018OneActive: 'Fintek didirikan, ',
      item2018One: 'terutama bergerak di bidang pengembangan SaaS pinjaman.',
      item2019OneActive: 'Cloudun Cayman & Singapura ',
      item2019One: 'didirikan pada Mei 2019.',
      item2019Two: 'Grup mulai menjelajahi AI teknologi keuangan dan layanan ',
      item2019TwoActive: 'teknologi di Indonesia.',
      item2020OneActive: 'Cloudun Indonesia ',
      item2020One: 'didirikan, mulai menyediakan layanan EKYC, wawasan kredit, dan konsultasi pinjaman digital di Indonesia.',
      item2021OneActive: 'Cloudun HK ',
      item2021One: 'didirikan, memulai bisnis di Meksiko, memperluas lini produk: Iklan AI.',
      item2021Two: 'Pada akhir tahun 2021, Cloudun menyediakan layanan untuk 67 klien perusahaan, dengan volume panggilan API lebih dari ',
      item2021TwoActive: '90 juta kali.',
      item2022OneActive: 'Cloudun Group ',
      item2022One: 'terus mengoptimalkan produk di pasar Meksiko dan Indonesia, terus meningkatkan klien perusahaan, dan mempertahankan pertumbuhan bisnis yang berkelanjutan. Pada tahun 2023, panggilan API telah mencapai 270 juta kali pada tahun itu.',
      item2022Two: 'Menyelesaikan Pendanaan Seri A.',
      item2024One: 'Atas dasar mempertahankan pertumbuhan yang stabil di pasar yang ada, Cloudun telah menjelajah secara horizontal ke wilayah lain seperti Filipina dan secara vertikal memajukan pengembangan sistem operasi cerdas seperti chatbot AI.',
      item2024Two: 'Pada Desember 2024, Cloudun telah menyediakan layanan untuk 90+ klien perusahaan dengan volume transaksi keuangan lebih dari US$5 miliar dolar, menghubungkan hampir 50 juta pengguna akhir.',
      item2024Three: 'Kami bermitra dengan pemain kunci di seluruh rantai industri, mendorong kolaborasi dan menciptakan nilai bersama.'
    }
  },
  solution: {
    slogan1: 'Bermitra Dengan Kami Untuk Pertumbuhan Yang Menguntungkan',
    subSlogan: 'Mulai dari konsultasi, pembentukan model bisnis, pengembangan dan penerapan yang disesuaikan, hingga panduan operasional dan analisis operasional pada tahap awal bisnis, dan akhirnya transfer lengkap strategi operasional dan kode, untuk mencapai solusi bisnis yang komprehensif.',
    businessGrowth: {
      title: 'Pertumbuhan nilai dan peningkatan efisiensi',
      subTitle: 'Pengalaman bisnis yang luas dan matang, serta pemantauan layanan yang terus-menerus, untuk memastikan bahwa tujuan dan sasaran bisnis dapat tercapai.'
    },
    consult: {
      title: 'Konsultasi dan Transaksi',
      subTitle: 'Pengiriman kode lengkap, pemikiran komersial, pelatihan strategi manajemen risiko dan pengajaran praktis, untuk memastikan klien kami memiliki kemampuan untuk terus menjalankan bisnis.'
    },
    customization: {
      title: 'Kustomisasi dan Penerapan',
      subTitle1: 'Solusi eksklusif yang disesuaikan dan berorientasi pada pelanggan;',
      subTitle2: 'Kontrol ketat proses implementasi untuk memaksimalkan manfaat.'
    }
  },
  el: {
    pleaseEnter: 'Silakan masuk',
    submit: 'Kirim'
  },
  publicNavigation: {
    navList: {
      item1: 'Beranda',
      item2: 'Produk',
      item3: 'Solusi',
      item4: 'Tentang Kami'
    },
    menuList: {
      item1Title: 'EKYC',
      item1Subtitle: 'Memberikan pengalaman autentikasi yang lebih lancar kepada pelanggan dan data autentikasi EKYC yang lebih andal kepada bisnis anda.',
      item2Title: 'Skor Kredit Cloudun',
      item2Subtitle: 'Memanfaatkan dataset besar dan model kontrol risiko multi-dimensi untuk menilai kelayakan kredit secara akurat, membantu bisnis mengurangi risiko sambil meningkatkan nilai transaksi setiap transaksi dan profitabilitas secara keseluruhan.',
      item3Title: 'Anti-Fraud AI',
      item3Subtitle: 'Iterasi Berkelanjutan untuk Mempertahankan Kemampuan Anti-Penipuan Terdepan di Industri, Selangkah Lebih Maju.',
      item4Title: 'Robot Suara Luna AI',
      item4Subtitle: 'Staf panggilan suara AI, cara terbaik untuk menjangkau pelanggan secara efisien di era baru.',
      item5Title: 'Layanan Iklan AI',
      item5Subtitle: 'Bersama tim iklan Cloudun, percepat akuisisi lalu lintas pasar luar negeri Anda: percepatan penempatan 10 kali lipat, pertumbuhan lalu lintas 10 kali lipat.'
    }
  },
  publicFooter: {
    products: 'Produk',
    product1: 'Iklan AI',
    product2: 'EKYC',
    product3: 'Robot Luna AI',
    product4: 'Layanan Anti-Fraud',
    product5: 'Layanan Kredit Skor',
    solutions: 'Solusi',
    solutions1: 'Solusi Ujung-ke-Ujung Pinjaman Online',
    solutions2: 'Solusi Lengkap Akuisisi Pengguna Pasar Luar Negeri',
    company: 'Perusahaan',
    company1: 'Tentang Kami',
    contactUs: 'Hubungi Kami',
    contactUs1: 'Telepon',
    contactUs2: 'Email'
  },
  newLunaAi: {
    joinCloudun: 'Bergabunglah dengan Cloudun, Memperkuat keuangan digital Anda dengan AI dan algoritma',
    newBanner: {
      title1: 'Cloudun Luna:',
      title2: 'Platform Penjangkauan Cerdas Satu Atap',
      subTitle: 'Mesin Pertumbuhan yang Terukur, Aman & Patuh untuk Layanan Keuangan Global'
    },
    characteristic: {
      name1: 'Agregasi Omni-Saluran',
      name2: 'Strategi Cerdas',
      name3: 'Percakapan Berbasis LLM',
      name4: 'Keamanan Kelas Finansial',
      subName1: 'Satu Koneksi, Jangkauan Menyeluruh',
      subName2: 'Routing Cerdas dengan Pengujian A/B',
      subName3: 'Pemahaman Niat Mendalam untuk Percakapan Cerdas',
      subName4: 'Tanpa Kebocoran Data, Kepatuhan Penuh'
    },
    specification: {
      number1: '100 juta+',
      number2: '+20%',
      number3: '+25%',
      number4: '80%',
      text1: '100 Juta+ Kontak Terjangkau',
      text2: 'Peningkatan Konversi Pemasaran Rata-rata: +20%',
      text3: 'Peningkatan Rata-rata Pemulihan Penagihan: +25%',
      text4: 'Tingkat Jangkauan Efektif 80%'
    },
    btns: {
      freeTrialBtn: 'Dapatkan Rencana Khusus Anda',
      bookDemoBtn: 'Pesan Demo'
    },
    useCase: {
      title: 'Kasus Penggunaan Utama',
      subTitle: 'Lintas Pemasaran, Layanan & Penagihan — Setiap Percakapan Cerdas Mendorong Pertumbuhan'
    },
    guidance: {
      title: 'Kami menawarkan uji coba gratis fitur lengkap dan validasi kinerja yang disesuaikan',
      subTitle: 'Hubungi kami untuk memulai perjalanan penjangkauan pelanggan berbasis AI Anda'
    },
    coreProduct: {
      title: 'Kemampuan Inti Produk',
      subTitle: 'Empat Mesin yang Menggerakkan Pertumbuhan Bisnis Keuangan',
      gainLabel: 'Apa yang Anda Dapatkan',
      results: 'Hasil yang Dicapai',
      tabs: {
        tab1: '5 Saluran Terpadu',
        tab2: 'Strategi Cerdas',
        tab3: 'Percakapan Berbasis LLM',
        tab4: 'Keamanan Kelas Finansial'
      },
      panels: {
        panel1: {
          title: '5 Saluran Global Utama, Integrasi Instan',
          subTitle: 'Satu Integrasi, Orkestrasi Omni-Saluran, Jangkauan Lebih Tinggi',
          feature1Title: 'Integrasi Satu Atap',
          feature1Desc: 'Integrasikan sekali dengan API Luna untuk mengaktifkan panggilan keluar AI, RCS, WhatsApp Business API (WABA), IVR, SMS, email, dan lainnya',
          feature2Title: 'Mesin Routing Cerdas',
          feature2Desc: 'Pilih dan alihkan saluran terbaik secara otomatis berdasarkan status pengguna, biaya, dan preferensi untuk meningkatkan jangkauan',
          stat1Value: '1-2 Weeks',
          stat1Label: 'Waktu integrasi dipersingkat menjadi 1-2 minggu',
          stat2Value: '80%+',
          stat2Label: 'Tingkat jangkauan efektif meningkat hingga 80%+',
          stat3Value: '20%',
          stat3Label: 'Biaya penjangkauan pelanggan berkurang 20%'
        },
        panel2: {
          title: 'Agen Pemasaran & Pengingat LLM untuk Keterlibatan Pelanggan yang Lebih Cerdas',
          subTitle: 'Dari Siaran Satu Arah ke Percakapan Cerdas',
          feature1Title: 'Pemahaman Niat Mendalam',
          feature1Desc: 'Didukung oleh LLM, Mengidentifikasi Niat & Emosi Pelanggan Secara Akurat — Akurasi 85%+',
          feature2Title: 'Pembuatan Respons Dinamis',
          feature2Desc: 'Hasilkan Respons Personal Secara Real-Time Berdasarkan Konteks — Melampaui Skrip Tetap',
          stat1Value: '200%+',
          stat1Label: 'Percakapan mendekati interaksi manusia dengan 200%+ lebih banyak giliran dialog',
          stat2Value: '12% → 29%',
          stat2Label: 'Deteksi niat tinggi meningkatkan konversi dari 12% menjadi 29% dalam skenario cicilan kartu kredit'
        },
        panel3: {
          title: 'Mesin Strategi Otomatisasi & Eksperimen',
          subTitle: 'Hubungkan saluran penjangkauan dan buat keputusan lebih baik dengan data',
          feature1Title: 'Orkestrasi Perjalanan Visual',
          feature1Desc: 'Bangun Alur Kerja Otomatis dengan Seret-dan-Lepas Sederhana',
          feature2Title: 'Routing Otomatis & Pengujian A/B',
          feature2Desc: 'Pisahkan segmen pelanggan secara otomatis ke berbagai strategi dan optimalkan berdasarkan hasil eksperimen',
          stat1Value: '3X',
          stat1Label: '3x lebih cepat peluncuran dan optimalisasi strategi',
          stat2Value: '15-20%',
          stat2Label: 'Pengujian A/B berkelanjutan mendorong pertumbuhan konversi 15-20% per kuartal'
        },
        panel4: {
          title: 'Fondasi Keamanan & Kepatuhan Kelas Finansial',
          subTitle: 'Landasan Kepercayaan untuk Layanan Keuangan',
          feature1Title: 'Keamanan Data',
          feature1Desc: 'Komunikasi dan penyimpanan terenkripsi ujung-ke-ujung, dengan dukungan penerapan privat untuk menjaga data inti tetap dalam lingkungan Anda',
          feature2Title: 'Operasi yang Patuh',
          feature2Desc: 'Pemantauan real-time dan aturan risiko bawaan membantu mencegah tindakan yang tidak patuh dan memenuhi regulasi privasi global',
          feature3Title: 'Jaminan Ketersediaan Tinggi',
          feature3Desc: 'Ketersediaan Layanan 99,99% dengan Arsitektur Pemulihan Bencana Kelas Finansial',
          stat1Value: 'MFA',
          stat2Value: 'Data Encryption',
          stat3Value: 'DDoS Protection'
        }
      }
    },
    customerPractice: {
      title: 'Kisah Sukses Klien',
      subTitle: 'Studi Kasus Nyata, Hasil Terbukti',
      cases: {
        case1: {
          quoteBefore: 'Panggilan keluar cerdas dan segmentasi tepat meningkatkan konversi pemasaran menjadi ',
          quoteHighlight: '15%',
          quoteAfter: ' dan meningkatkan efisiensi jangkauan',
          label: 'Kasus 1',
          tag: 'Percakapan AI + Routing Cerdas'
        },
        case2: {
          quoteBefore: 'Pengingat pembayaran otomatis meningkatkan tingkat pembayaran pra-jatuh tempo menjadi ',
          quoteHighlight: '83%',
          quoteAfter: ', mengurangi biaya penagihan manual dan meningkatkan pemulihan pembayaran',
          label: 'Kasus 2',
          tag: 'Mesin Strategi Otomatis'
        },
        case3: {
          quoteBefore: 'Routing otomatis dan percakapan multi-giliran meningkatkan aktivasi pengguna tidak aktif menjadi ',
          quoteHighlight: '23%',
          quoteAfter: ' dan mendorong kembali minat pinjaman ulang',
          label: 'Kasus 3',
          tag: 'Pengujian A/B + Routing Presisi'
        }
      }
    }
  }
}
